import React from 'react';
import BaseAsyncSelectBox from 'components/atoms/base-select-box/async';
import { useCustomerTypeSelect } from 'infrastructure/hooks/select/use-customer-type-select';

import type { BaseSelect } from 'infrastructure/classes/select/base-select';
import type { IPaginationMeta } from 'infrastructure/interfaces';
import type { IBaseAsyncSelectBoxProps } from 'components/atoms/base-select-box/types';

type IProps = IBaseAsyncSelectBoxProps<any, BaseSelect>;

const CustomerTypeSelectBox: React.FC<IProps> = (props) => {
  const { onLoaded } = props;

  const { meta, loadCustomerTypes } = useCustomerTypeSelect();

  const fetchOptions = async (search: string, metaProps: IPaginationMeta) => {
    const items = await loadCustomerTypes({
      ...metaProps,
      search,
    });

    if (items)
      return items.map((el) => {
        return {
          label: el.label,
          value: el.guid,
          record: el,
        };
      });

    return [];
  };

  return (
    <BaseAsyncSelectBox
      fetchOptions={fetchOptions}
      meta={meta}
      onValueLoaded={onLoaded}
      canSearch
      {...props}
    />
  );
};

export default CustomerTypeSelectBox;
